import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {fetchShareOptaviaPlan} from '/redux/action/client.action';
import {
  coachAliasById,
  hasCoachAliasById,
} from '/redux/selector/client.selector';
import {
  highestAchievedRankDescriptionById,
  paidAsRankDescLastMonth,
  rankDescriptionById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withProps} from '/util/selector.util';

import ShareOptaviaPlan from './ShareOptaviaPlan';

const withCurrentUserCoachId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    coachId: userId,
    coachAlias: withCurrentUserCoachId(coachAliasById),
    hasCoachAlias: withCurrentUserCoachId(hasCoachAliasById),
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    highestRankDescription: withProps({coachId: userId})(
      highestAchievedRankDescriptionById,
    ),
    coachCurrentRank: withProps({coachId: userId})(rankDescriptionById),
  }),
  dispatch => ({
    fetchShareOptaviaPlan: ({coachId}: any) =>
      dispatch(fetchShareOptaviaPlan({coachId})),
  }),
  (stateProps, dispatchProps, ownProps) => {
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      fetchShareOptaviaPlan: () => {
        const {coachId} = stateProps;
        return dispatchProps.fetchShareOptaviaPlan({
          coachId,
        });
      },
    };
  },
)(ShareOptaviaPlan);
